import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LANGUAGE } from '../store/slices/settingsSlice';
// import Backend from 'i18next-http-backend';

import commonRu from './locales/ru/common.json';
import commonEn from './locales/en/common.json';
import pvtRu from './locales/ru/pvt.json';
import pvtEn from './locales/en/pvt.json';
import water_contentRu from './locales/ru/water_content.json';
import water_contentEn from './locales/en/water_content.json';
import hydrateRu from './locales/ru/hydrates.json';
import hydrateEn from './locales/en/hydrates.json';
import profileRu from './locales/ru/profile.json';
import profileEn from './locales/en/profile.json';
import iprEn from './locales/en/ipr.json';
import iprRu from './locales/ru/ipr.json';
import vlpEn from './locales/en/vlp.json';
import vlpRu from './locales/ru/vlp.json';
import gasRateCriticalRu from './locales/ru/gas_rate_critical.json';
import gasRateCriticalEn from './locales/en/gas_rate_critical.json';
import pressureDropRu from './locales/ru/pressure_drop.json';
import pressureDropEn from './locales/en/pressure_drop.json';
import materialBalanceRu from './locales/ru/material_balance.json';
import materialBalanceEn from './locales/en/material_balance.json';

const resources = {
	ru: {
		common: commonRu,
		pvt: pvtRu,
		water_content: water_contentRu,
		hydrates: hydrateRu,
		profile: profileRu,
		ipr: iprRu,
		vlp: vlpRu,
		grc: gasRateCriticalRu,
		pressure_drop: pressureDropRu,
		material_balance: materialBalanceRu,
	},
	en: {
		common: commonEn,
		pvt: pvtEn,
		water_content: water_contentEn,
		hydrates: hydrateEn,
		profile: profileEn,
		ipr: iprEn,
		vlp: vlpEn,
		grc: gasRateCriticalEn,
		pressure_drop: pressureDropEn,
		material_balance: materialBalanceEn,
	},
};


i18n
	// .use(Backend)
	.use(initReactI18next)
	.init({
		// backend: {
		// 	loadPath: 'frontend/src/i18n/locales/{{lng}}/{{ns}}.json',
		// },
		resources,
		ns: ['common', 'pvt', 'water_content', 'hydrate_formation', 'profile', 'ipr', 'vlp', 'grc', 'pressure_drop', 'material_balance'],
		defaultNS: 'common',
		fallbackNS: 'common',
		lng: DEFAULT_LANGUAGE,
		fallbackLng: DEFAULT_LANGUAGE,
		supportedLngs: ['ru', 'en'],
		interpolation: {
			escapeValue: false
		},
		preload: ['common', 'pvt', 'water_content', 'hydrate_formation', 'profile', 'ipr', 'vlp', 'grc', 'pressure_drop', 'material_balance'],
	});

export default i18n;